export default __webpack_public_path__ + "static/media/project1.34e5e0e6.png";